// src/components/ErrorBoundary.jsx
import React from 'react';

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    console.error('Chart render error:', error, info);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{
          padding: '1.5rem',
          backgroundColor: '#ffebee',
          border: '1px solid #f44336',
          borderRadius: '4px',
          color: '#c62828',
          textAlign: 'center'
        }}>
          <strong>Chart failed to render.</strong>
          <div style={{ fontSize: '0.9em', marginTop: '0.5rem', color: '#555' }}>
            {this.state.error?.message}
          </div>
          <button
            onClick={() => this.setState({ hasError: false, error: null })}
            style={{
              marginTop: '1rem',
              padding: '4px 12px',
              cursor: 'pointer',
              border: '1px solid #c62828',
              borderRadius: '4px',
              backgroundColor: 'white',
              color: '#c62828'
            }}
          >
            Retry
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
